export enum DocsApiErrorCode {
    CommitIdOutOfSync = 250_000,
    InsufficientPermissions = 2011,
    InvalidID = 2061,
    Unknown = 0,
}
